import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  updateDoc,
  orderBy,
  startAfter,
  getCountFromServer,
  where,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "predictions", id);
};

export const getData = async (reference) => {
  if (reference) {
    const docSnap = await getDoc(reference);
    return docSnap.exists ? { id: docSnap?.id, ...docSnap.data() } : null;
  }
  return null;
};

export const getPredictions = async (last, filters = {}) => {
  try {
    // Build the base query
    let q = query(
      collection(db, "predictions"),
      orderBy("createdAt", "desc"),
      ...(last ? [startAfter(last)] : []),
      limit(10),
    );

    // Conditionally add filter clauses
    if (!!filters.categories?.length) {
      q = query(
        q,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const predictions = documentSnapshots.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    // Build the query for the total count
    let queryCount = query(
      collection(db, "predictions"),
      orderBy("createdAt", "desc"),
    );

    if (!!filters.categories?.length) {
      queryCount = query(
        queryCount,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    const countSnapshot = await getCountFromServer(queryCount);
    const totalPredictionsCount = countSnapshot.data().count;

    // Return predictions, last document, and total count of predictions
    return { predictions, last: lastVisible, totalPredictionsCount };
  } catch (error) {
    console.error(`Error while getting predictions: ${error}`);
    return error;
  }
};

export const getPredictionById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const prediction = docSnap.data();
  return docSnap.exists
    ? { id: docSnap.id, ...prediction, category: [], reviewers: [] }
    : null;
};

export const updatePredictions = async (id, data) => {
  try {
    await updateDoc(getDocument(id), data);
  } catch (e) {
    console.error(`Error while updating prediction ${e}`);
    return false;
  }
};
